import React from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import JobsList from './components/JobsList'
import JobDetail from './components/JobDetail'
import ExhibitorProfile from './components/ExhibitorProfile'

// Routen der Stellen-App. Eigenes Modul, damit Tests denselben Baum mit
// createMemoryRouter fahren. Ein Wechsel innerhalb der App (Seite 2 der
// Liste, Liste -> Anzeige) laedt keine neue Seite; ScrollRestoration setzt
// wie ein aufgerufener Link nach oben zurueck (#223).
const Rahmen = () => (
    <>
        <ScrollRestoration />
        <Outlet />
    </>
)

const jobsRoutes = [{
    element: <Rahmen />,
    children: [
        { path: '/stellenangebote/', element: <JobsList /> },
        { path: '/stellenangebote/:slug/', element: <JobDetail /> },
        // Aussteller-Profilseite (#239): eigene WordPress-Seite /aussteller/,
        // dieselbe App und derselbe Router (PublicPages.php).
        { path: '/aussteller/:id/', element: <ExhibitorProfile /> }
    ]
}]

export default jobsRoutes
